{
  "ai.title": "AI assistant",
  "ai.provider.available": "Available",
  "ai.provider.unavailable": "Not available",
  "ai.provider.test_label": "BRES test adapter",
  "ai.provider.test_badge": "Test adapter",
  "ai.provider.tm": "Translation memory",
  "ai.provider.test_title": "No language model: test output only",
  "ai.provider.test_body": "The BRES test adapter runs locally. It does not translate: a proposal is the source text with a test label, and the cost is always zero. This lets you test budget, fact check and review without real AI.",
  "ai.provider.off_body": "No AI provider is set up. Translating and reviewing by hand works as usual.",
  "ai.provider.rule_proposals": "AI only makes proposals. A reviewer of the language decides.",
  "ai.provider.rule_facts": "Prices, areas and other facts come from the listing details, never from AI.",
  "ai.budget.title": "Budget this month",
  "ai.budget.set": "Set budget",
  "ai.budget.day": "Day {day} of {days}",
  "ai.budget.of_limit": "of {limit}",
  "ai.budget.no_limit": "no limit",
  "ai.budget.bar_label": "{spent} of {limit} used, day {day} of {days}",
  "ai.budget.none": "No monthly budget is set; AI tasks are not limited.",
  "ai.budget.hard_stop_on": "Hard stop: at the budget no new AI tasks start. Existing translations keep working.",
  "ai.budget.hard_stop_off": "No hard stop: AI tasks continue above the budget.",
  "ai.budget.ahead": "Spending is ahead of the month.",
  "ai.budget.no_rights": "An admin sets the budget.",
  "ai.budget.by_task": "{count, plural, =0 {Per task} one {Per task, # task this month} other {Per task, # tasks this month}}",
  "ai.budget.by_task_empty": "No AI tasks this month yet.",
  "ai.budget.task_count": "{count, plural, one {{n} task} other {{n} tasks}}",
  "ai.budget.dialog_title": "Monthly AI budget",
  "ai.budget.dialog_body": "Applies to all AI tasks of this organisation, per calendar month.",
  "ai.budget.amount": "Amount per month",
  "ai.budget.amount_hint": "Between 0 and 10,000.",
  "ai.budget.amount_invalid": "Choose an amount between 0 and 10,000.",
  "ai.budget.hard_stop": "Hard stop at the budget",
  "ai.budget.save": "Save budget",
  "ai.budget.saved": "Budget saved",
  "ai.budget.saved_body": "New limit: {limit} per month.",
  "ai.jobs.title": "Recent tasks",
  "ai.jobs.lead": "{count, plural, =0 {No tasks yet.} one {The latest task, with origin and cost.} other {The latest # tasks, with origin and cost.}}",
  "ai.jobs.col_task": "Task",
  "ai.jobs.col_outcome": "Outcome",
  "ai.jobs.col_by": "Started by",
  "ai.jobs.col_usage": "Cost",
  "ai.jobs.col_created": "Started",
  "ai.jobs.by_system": "System",
  "ai.jobs.tokens": "{in} in, {out} out",
  "ai.jobs.tokens_title": "Input tokens and output tokens",
  "ai.jobs.error_detail": "Error: {error}",
  "ai.jobs.test_output": "Test output (no language model)",
  "ai.jobs.origin": "Origin",
  "ai.jobs.any_task": "All tasks",
  "ai.jobs.any_origin": "All",
  "ai.jobs.origin_provider": "AI provider",
  "ai.jobs.origin_test": "Test output",
  "ai.jobs.clear": "Clear filters",
  "ai.jobs.empty_title": "No AI tasks yet",
  "ai.jobs.empty_body": "Request an AI proposal in Languages, Proposals.",
  "ai.jobs.empty_action": "Go to Proposals",
  "ai.jobs.empty_filtered_title": "No tasks with these filters",
  "ai.jobs.empty_filtered_body": "Choose another task or origin.",
  "ai.task.localize": "Translation proposal",
  "ai.task.brief_from_text": "Search brief from text",
  "ai.task.reply_draft": "Reply draft",
  "ai.task.quality_review": "Quality check",
  "ai.status.queued": "Queued",
  "ai.status.running": "Running",
  "ai.status.succeeded": "Proposal made",
  "ai.status.failed": "Failed",
  "ai.status.blocked_budget": "Stopped by budget",
  "ai.status.blocked_checks": "Fact check failed",
  "ai.status.accepted": "Adopted",
  "ai.status.rejected": "Rejected",
  "ai.outcome.draft": "Sent back",
  "ai.outcome.proposed": "Waiting for review",
  "ai.outcome.in_review": "Waiting for review",
  "ai.outcome.approved": "Approved",
  "ai.outcome.rejected": "Rejected",
  "ai.outcome.stale": "Outdated",
  "ai.outcome.superseded": "Replaced",
  "ai.evals.title": "Evaluations",
  "ai.evals.lead": "Fixed sample texts per language go through the provider. BRES checks facts, script and content per language.",
  "ai.evals.run": "Run evaluation",
  "ai.evals.no_rights": "An admin runs evaluations.",
  "ai.evals.provider_off": "Without a provider there is nothing to evaluate.",
  "ai.evals.done": "Evaluation done: {passed} of {total} passed",
  "ai.evals.done_test": "Test adapter: the result says nothing about translation quality.",
  "ai.evals.run_label": "Evaluation",
  "ai.evals.run_option": "{when}, {passed} of {total}",
  "ai.evals.summary": "{passed} of {total} languages passed",
  "ai.evals.cost": "Cost {cost}",
  "ai.evals.test_note": "The test adapter does not translate. A passed language only means that numbers and script are right in the untranslated source; it says nothing about translation quality.",
  "ai.evals.quality_note": "A passed evaluation tests facts and script, not language quality. Native review is still needed.",
  "ai.evals.table_label": "Result per language",
  "ai.evals.expects_script": "expects {script} script",
  "ai.evals.col_locale": "Language",
  "ai.evals.col_facts": "Facts",
  "ai.evals.col_script": "Script",
  "ai.evals.col_content": "Content",
  "ai.evals.col_result": "Result",
  "ai.evals.facts_ok": "Match",
  "ai.evals.facts_bad": "{count, plural, =0 {Mismatch} one {# mismatch} other {# mismatches}}",
  "ai.evals.script_ok": "Right script",
  "ai.evals.script_bad": "Wrong script",
  "ai.evals.content_ok": "Filled",
  "ai.evals.content_bad": "Empty",
  "ai.evals.passed": "Passed",
  "ai.evals.failed": "Failed",
  "ai.evals.empty_title": "No evaluation yet",
  "ai.evals.empty_body": "Run an evaluation to see per language whether the provider keeps facts and script right.",
  "ai.plan.title": "Your AI features",
  "ai.plan.lead": "Which AI features are in your plan. BRES switches them on per organisation or per site.",
  "ai.plan.not_in_plan": "Not in your plan",
  "ai.plan.included": "In your plan",
  "ai.plan.whole_tenant": "Whole organisation",
  "ai.plan.since": "since {date}",
  "ai.plan.request_button": "Register interest",
  "ai.plan.request_short": "Interest",
  "ai.plan.request_open": "Interest registered",
  "ai.plan.request_title": "Interest in {feature}",
  "ai.plan.request_site": "For the site {site}.",
  "ai.plan.request_message": "Message to BRES",
  "ai.plan.request_send": "Register interest",
  "ai.plan.requested_title": "Interest registered",
  "ai.plan.requested_body": "BRES will contact you about pricing and options.",
  "ai.plan.ask_owner": "Ask the owner of your organisation to register interest.",
  "ai.plan.paid_note": "Paid extension, on or off per site.",
  "ai.feature.translation": "AI translation proposals",
  "ai.feature.translation_pitch": "Translation proposals for listing texts in the languages of your site, with fact checks and review by your team.",
  "ai.feature.translation_point1": "Facts such as price and size stay exactly the same",
  "ai.feature.translation_point2": "Your glossary is followed",
  "ai.feature.translation_point3": "Nothing goes live without approval",
  "ai.feature.assist": "AI help with enquiries",
  "ai.feature.assist_pitch": "Turn a free-text wish into search criteria and draft a reply to an enquiry.",
  "ai.feature.assist_point1": "Search criteria from an email or note",
  "ai.feature.assist_point2": "Draft reply in the client's language",
  "ai.feature.assist_point3": "You review and send it yourself",
  "ai.feature.blog": "AI blog",
  "ai.feature.blog_pitch": "Articles per language about your area and the buying process, with facts from your own source list and advice that fits the reader's country.",
  "ai.feature.blog_point1": "Draft per language, you rewrite and approve",
  "ai.feature.blog_point2": "SEO checks, internal links to areas and properties",
  "ai.feature.blog_point3": "Published through your normal website publication",
  "ai.feature.chat": "AI chatbot",
  "ai.feature.chat_pitch": "An assistant on your website that answers questions with your real listings and your own knowledge, and with their consent turns visitors into an enquiry.",
  "ai.feature.chat_point1": "Answers with links to real properties",
  "ai.feature.chat_point2": "Enquiry in BRES only with consent",
  "ai.feature.chat_point3": "Cost cap per day and per month",
  "ai.task.blog_draft": "Blog draft",
  "ai.task.chat_reply": "Chat answer",
  "ai.budget.cap_note": "BRES cap: {cap} per month"
}
